import { CreateTeamMemberForm } from '../../features/CreateTeamMember/ui/CreateTeamMemberForm';

const CreateTeamMemberPage = () => {
  return <CreateTeamMemberForm />;
};

export default CreateTeamMemberPage;
